import Form from './Form'
import FormGroup from './FormGroup.js'
import FormItem from './FormItem.js'

Form.Group = FormGroup
Form.Item = FormItem

export default Form
